const shortDate = value => {
    const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    return match ? `${match[3]}.${match[2]}.${match[1]}` : '';
};

function assignmentText(evidence) {
    if (!evidence) return '';
    const kind = {primary_object: 'Основное назначение на объект', primary_group: 'Назначение на группу объектов',
        additional: 'Дополнительное назначение на объект'}[evidence.kind] || 'Назначение на объект';
    const from = evidence.effective_from || evidence.source_effective_from || evidence.starts_on;
    const until = evidence.effective_to || evidence.source_effective_to;
    const period = evidence.starts_on ? `В табеле: ${shortDate(evidence.starts_on)} — ${shortDate(evidence.ends_on)}.` : '';
    const actors = (evidence.authorship || []).map(actor => {
        const label = {assigned: 'Назначил', planned: 'Запланировал', confirmed: 'Прибытие подтвердил'}[actor.role];
        const name = actor.name || (actor.imported ? 'Импортировано; автор назначения не указан' : 'Автор не указан');
        const effective = actor.effective_on ? ` · с ${shortDate(actor.effective_on)}` : '';
        const recorded = actor.recorded_at ? ` (запись ${shortDate(actor.recorded_at)})` : '';
        return `${label}: ${name}${effective}${recorded}`;
    });
    return [`${kind}${from ? ' с ' + shortDate(from) : ''}${until ? ' до ' + shortDate(until) + ' (не включая)' : ''}.`, period,
        ...(actors.length ? actors : ['Автор не указан'])].filter(Boolean).join('\n');
}

function buildAssignmentPresentation(lines) {
    const result = {};
    (lines || []).forEach(line => {
        const evidence = line.assignment_evidence || {};
        const ranges = (evidence.ranges || []).slice().sort((a, b) => String(b.starts_on).localeCompare(String(a.starts_on)));
        result[Number(line.id)] = {
            month: ranges.map(assignmentText).join('\n\n'),
            days: (evidence.days || []).reduce((days, day) => {days[day.date] = assignmentText(day); return days;}, {})
        };
    });
    return result;
}

function assignmentNotices(evidence, selectedDate, objectName) {
    const source = evidence || {};
    const rows = selectedDate ? (source.days || []).filter(day => day.date === selectedDate)
        : (source.ranges || []).slice().sort((a, b) => String(b.starts_on).localeCompare(String(a.starts_on)));
    return rows.map((row, index) => {
        const from = row.effective_from || row.source_effective_from || row.starts_on;
        const kind = row.kind === 'primary_group' ? ' (назначение на группу объектов)'
            : row.kind === 'additional' ? ' (дополнительное назначение)' : '';
        return {id: `timesheet-assignment:${index}`, timesheet_assignment: true,
            label: `С ${shortDate(from)} — ${objectName || 'Объект не указан'}${kind}`,
            authors: (row.authorship || []).map(actor => ({...actor,
                label: {assigned: 'Назначил', planned: 'Запланировал', confirmed: 'Прибытие подтвердил'}[actor.role]}))};
    });
}

export default {assignmentText, buildAssignmentPresentation, assignmentNotices};
